export type User = {
  id: string;
  name: string;
  email: string;
  photoUrl?: string;
  permissions: Permission[];
  lastLoggedIn: string;
  lastUpdatedProfile: string;
  roles: string[];
  isActive: boolean;
};

export type Permission = {
  code: string;
  title: string;
};

export const UserPermissions = {
  VIEW_USERS: 'users.read',
  EDIT_USERS: 'users.update',
} as const;

export const UserRoles = {
  ADMIN: 'Admin',
  USER: 'User',
} as const;
